<template>
    <header-layout></header-layout>
    <div class="page-padding">
        <div class="price-bg"></div>
        <div class="large-title">最新动态</div>
        <a-carousel class="carousel" autoplay>
            <div>
                <img class="carousel-cover" src="@/assets/image/banner_2400_1200_48471f3f01.png" loading="lazy" />
            </div>
            <div>
                <img class="carousel-cover" src="@/assets/image/Master_Go_2x_79e50ad839.png" loading="lazy" />
            </div>
            <div>
                <img class="carousel-cover" src="@/assets/image/2x_8ad5f724ed.png" loading="lazy" />
            </div>
        </a-carousel>

        <div class="large-title" style="margin-bottom: 1rem;">持续更新</div>
        <section class="article-card" data-v-367f7320="">
            <div class="content"><a class="item">
                    <div class="img-box"><img src="@/assets/image/blog_1_3x_1_a8f252cd73.png" loading="lazy"></div>
                    <div class="text-box">
                        <div class="time">2022年04月20日 · 功能更新</div>
                        <div class="title">功能更新｜MasterGo 支持 Figma 一键导入，工作内容无缝衔接！</div>
                        <div class="description">将 Figma 文件的链接复制到“导入窗口”，即可一键导入并解析成 MasterGo
                            文件，之后您可查看并继续用
                            MasterGo 编辑文件，真正实现工作的无缝衔接。</div>
                    </div>
                </a><a class="item">
                    <div class="img-box"><img src="@/assets/image/20220424_182030_1ae9d5c90a.png" loading="lazy"></div>
                    <div class="text-box">
                        <div class="time">2022年04月24日 · 功能更新</div>
                        <div class="title">MasterGo 插件广场上线之后，我们想说……</div>
                        <div class="description">MasterGo
                            推出了插件功能并上线了插件广场，首批插件资源可以提供“矩阵复制”、“批量倾斜”、“图片自动取色”等服务，极大简化了设计步骤，大大提升了设计体验，也因此受到很多设计师的好评。但让我们欣喜的，还远不止于此。
                        </div>
                    </div>
                </a><a class="item">
                    <div class="img-box"><img src="@/assets/image/20220420_170223_78ca5e9fff.jpeg" loading="lazy"></div>
                    <div class="text-box">
                        <div class="time">2022年04月22日 · 行业动态</div>
                        <div class="title">MasterGo 联合新华网宣布“国产设计软件共创计划”正式启动</div>
                        <div class="description">4 月 20 日，由新华网、蓝湖 MasterGo 共同主办的“携手同行 共创未来”——2022
                            数字协同创新大会暨 MasterGo 国产设计软件共创计划启动仪式在京圆满举行。</div>
                    </div>
                </a><a class="item">
                    <div class="img-box"><img src="@/assets/image/98_Top_100_2x_64dd47f837.png" loading="lazy"></div>
                    <div class="text-box">
                        <div class="time">2022年03月17日 · 行业动态</div>
                        <div class="title">行业动态｜98% 中国 Top 100 互联网公司背后， 一只企服独角兽范本：蓝湖如何抓住数字经济机遇？</div>
                        <div class="description">为什么中国企业服务赛道鲜见独角兽？蓝湖取得的成绩更像是在用 To C 互联网业务模式，在 To B
                            端自下向上形成影响力，定位数字创造经济，迎接万亿美元市场的未来挑战。</div>
                    </div>
                </a><a class="item">
                    <div class="img-box"><img src="@/assets/image/Master_Go_2x_b506cdc8e8.png" loading="lazy"></div>
                    <div class="text-box">
                        <div class="time">2022年03月17日 · 产品测评</div>
                        <div class="title">产品测评｜被誉为设计师面试必备神器的 MasterGo，是如何被设计师认可的</div>
                        <div class="description">高效、智能、协作，试用过后我们发现，在不久的将来，MasterGo 将有可能成为设计师面试必备技能。
                        </div>
                    </div>
                </a><a class="item">
                    <div class="img-box"><img src="@/assets/image/Master_Go_2x_7465da22f6.png" loading="lazy"></div>
                    <div class="text-box">
                        <div class="time">2022年03月17日 · 功能更新</div>
                        <div class="title">功能更新｜对着屏幕比划才算有效沟通？MasterGo 「评论」功能重磅上线</div>
                        <div class="description">MasterGo 全新「评论」功能，表情回复，直接上图，随时编辑，评论定位，还能 @
                            协同者，收发通知，再不用对着屏幕比比划划了。</div>
                    </div>
                </a><a class="item">
                    <div class="img-box"><img src="@/assets/image/UI_2x_de08f771dd.png" loading="lazy">
                    </div>
                    <div class="text-box">
                        <div class="time">2022年03月17日 · 功能更新</div>
                        <div class="title">功能更新｜UI 组件，可以像搭积木一样自由组合吗？</div>
                        <div class="description">「组件状态」支持自定义可变组件的属性和值，多种状态样式一键切换。
                            更少组件，简单命名，高效接管设计系统，多“集”入口，轻松添加组件状态，将设计与开发紧紧串联，避免重复操作、确保高效交付与开发。</div>
                    </div>
                </a><a class="item">
                    <div class="img-box"><img src="@/assets/image/Master_Go_GIF_2x_3bfe153769.png" loading="lazy"></div>
                    <div class="text-box">
                        <div class="time">2022年03月17日 · 功能更新</div>
                        <div class="title">功能更新｜MasterGo 助你给设计来点儿表情和 GIF 吧！</div>
                        <div class="description">「评论功能」支持表情评论，拉近沟通距离，「原型功能」支持 GIF 播放，让原型演示更加生动。</div>
                    </div>
                </a><a class="item">
                    <div class="img-box"><img src="@/assets/image/525_2x_96a751d7aa.png" loading="lazy">
                    </div>
                    <div class="text-box">
                        <div class="time">2022年03月17日 · 使用技巧</div>
                        <div class="title">设计师纯享 | 525 种「颜值」与「文化」并存的中国风配色</div>
                        <div class="description">「资源广场」内置 525 种中国最美传统色，每一种颜色都有着别致的名字，并且标注有对应的 HEX
                            色值，方便设计师精准快捷的使用和搭配，为设计增加一抹中国色彩。</div>
                    </div>
                </a><a class="item">
                    <div class="img-box"><img src="@/assets/image/T_Design_up_up_2x_9137fb8377.png" loading="lazy">
                    </div>
                    <div class="text-box">
                        <div class="time">2022年03月17日 · 使用技巧</div>
                        <div class="title">资源推荐｜大厂设计师亲测好用，搬砖效率 UP UP</div>
                        <div class="description">「资源广场」内置丰富的大厂开源 UI 组件库，创建副本即可轻松使用，本期介绍的是
                            TDesign，包含了移动端和桌面端组件库素材，颜色、字体、按钮样式、UI 版式等完整的视觉风格规范和组件资源。</div>
                    </div>
                </a></div>
        </section>
    </div>
    <footer-layout></footer-layout>
</template>

<script>
import FooterLayout from './layout/footerLayout.vue'
import headerLayout from './layout/headerLayout.vue'
export default {
    components: { headerLayout, FooterLayout },
}
</script>

<style scoped>
.price-bg {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    width: 100%;
    height: 100vh;
    background-image: linear-gradient(to bottom, #d0f6f5, #FFFEFF);
    z-index: -1;
}

.large-title {
    font-size: 50px;
    font-weight: 800;
    line-height: 60px;
    text-align: center;
    letter-spacing: 0em;
    color: rgba(0, 0, 0, 0.85);
    margin: 5% 0;
    height: 100px;
}

.article-card {
    padding: 1rem 5%;
}

.content {
    display: grid;
    justify-content: center;
    grid-template-columns: 1fr 1fr;
    gap: 40px 34px;
    -webkit-box-align: center;
    margin: 0 auto;
    max-width: 1200px;
}

.content .img-box {
    position: relative;
    padding-bottom: 47.17%;
}

.content .img-box img {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    border-radius: 16px;
    transition: all .3s;
}

.content .time {
    padding: 16px 0;
    font-size: 14px;
    line-height: 14px;
    color: #656473;
}

.content {
    padding: 0 5%
}

.content .title {
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    text-align: justify;
    color: #121127;
}

.content .description {
    padding: 8px 0 0;
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    text-align: justify;
    color: #121127;
}

.content>.item {
    transition: transform 0.3s;
}

.content>.item:hover {
    transform: scale(1.04);
}

.carousel {
    margin: 0 10%;
    border-radius: 16px;
    overflow: hidden;
}

.carousel-cover {
    width: 100%;
}

@media (max-width: 765px) {

    .carousel {
        margin: 0 5%;
    }

    .large-title {
        font-size: 32px;
        height: 100px;
        line-height: 100px;
    }

    .article-card .content {
        grid-template-columns: 1fr;
        gap: 40px 34px;
    }

    .content .time {
        padding: 10px 0;
    }
}
</style>